import { INITIALIZE_CONFIG } from './constants/ActionTypes';
export const storeEnvironmentConfig = config => dispatch => {
  dispatch({
    type: INITIALIZE_CONFIG,
    config
  });
};